import { appSelectors } from '@appStore/reducers/app'
import store from '@appStore/store'
import { workspaceApi } from 'features/workspace'
import { useEffect } from 'react'
import { appConnector } from 'shared/connector'
import { useAppSelector } from 'shared/hooks'

function refetchAutomationMode() {
	const action = workspaceApi.endpoints.automationMode.initiate(undefined, {
		forceRefetch: true,
		subscribe: false
	})
	store.dispatch(action)
}

function useReactOnLinkedInStatus() {
	const isInstalled = useAppSelector(appSelectors.isInstalled)

	useEffect(() => {
		if (!isInstalled) {
			return
		}

		appConnector.eventHandlers.addLinkedInProfileDetectedHandler(
			refetchAutomationMode
		)
		appConnector.eventHandlers.addLinkedInSignedOutEventHandler(
			refetchAutomationMode
		)
	}, [isInstalled])
}

export { useReactOnLinkedInStatus }
